/**
 * Provides a way to clear the client-side session if the user just
 * logged out. The main things that need to be cleared are session and
 * local storage, but other things could be added to here as well.
 *
 * To trigger this the server needs to set a cookie named
 * `just-logged-out` after the user is signed out.
 */
import { deleteCookie, getCookies, } from "../cookies";
const cookieName = "just-logged-out";
function clearSessionIfJustLoggedOut() {
    if (getCookies(cookieName).length > 0) {
        for (const storage of [sessionStorage, localStorage]) {
            try {
                storage.clear();
            }
            catch (_a) {
                // No access to storage
            }
        }
        deleteCookie(cookieName);
    }
}
clearSessionIfJustLoggedOut();
